import { postMethodEncrypt, getMethod } from "@/http";
import api from "./api";

export const loginDB = (params) => postMethodEncrypt(api.login, params);
export const showCodeDB = (params) => postMethodEncrypt(api.showCode, params);
export const unbundlingDB = (params) =>
  postMethodEncrypt(api.unbundling, params);
export const findUserByActivationCodeDB = (params) =>
  getMethod(api.findUserByActivationCode, params);
export const findUserByRxUserNameDB = (params) =>
  getMethod(api.findUserByRxUserName, params);

export const getActivateBookListDB = (params) =>
  postMethodEncrypt(api.getActivateBookList, params);
export const getGwActivateBookListDB = (params) =>
  postMethodEncrypt(api.getGwActivateBookList, params);
export const getBookUnitLessonListDB = (params) =>
  postMethodEncrypt(api.getBookUnitLessonList, params);
export const getGwBookUnitLessonListDB = (params) =>
  postMethodEncrypt(api.getGwBookUnitLessonList, params);
export const getBookExercisesListDB = (params) =>
  postMethodEncrypt(api.getBookExercisesList, params);
export const getGwBookExercisesListDB = (params) =>
  postMethodEncrypt(api.getGwBookExercisesList, params);
export const activeBookDB = (params) =>
  postMethodEncrypt(api.activeBook, params);
export const resetActivationCodeDB = (params) =>
  postMethodEncrypt(api.resetActivationCode, params);
export const queryCodeDB = (params) => postMethodEncrypt(api.queryCode, params);
